import React from 'react'
import { Routes, Route } from 'react-router-dom'

import NoAuthHome from './NoAuthHome';
import ErrorPage from "./ErrorPage";
import Test from '../../Test/Test';
import OpenLayers from '../../Test/OpenLayers';

function NoAuthHomePage(){
    return (
        <div>
            <header className='landingpage-header'>
                <div className='title-container'>
                    <h1> AQcast2.0 </h1>
                </div>
            </header>
            <main className='main'>
                <div style={{borderTop: '2px solid black'}}></div>

                <Routes>
                    <Route path='/' element={<NoAuthHome/>} />
                    <Route path='/test' element={<Test/>}/>
                    <Route path='/openlayers' element={<OpenLayers/>}/>
                    <Route path='*' element={<ErrorPage/>}/>
                </Routes>
            </main>
        </div>
    );
}

export default NoAuthHomePage
